// Angular
import { CommonModule, DatePipe } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

// Ionic
import {
  IonContent,
  IonButton,
  IonSelect,
  IonSelectOption,
  IonIcon,
  ModalController,
  IonModal
} from '@ionic/angular/standalone';

// Local library
import {
  RaceStringToRangePipe,
  GetCurrentRacePipe,
  GetRaceStatusPipe,
  SortEventsPipe,
  GetEventStatusPipe,
  GetTrackTypePipe,
  ConvertToRangePipe,
  LegHeightDirective,
  OrdinalsPipe,
  HorseWeightPipe,
  NumberWithCommasPipe,
  CountdownPipe,
  FormatAmountPipe,
  SanitizerPipe,
  UnsubscribeObservableService
} from '@amwager/util';
import { CommonFacade, PermissionService, SessionService } from '@amwager/data-access';
import { GUEST, IGetEventsDetailsResponse, IPool, IRace } from '@amwager/util-ts';
import { RaceFinalComponent } from '@amwager/wager/ui-ion';
import { ISelectedRace, ISelectedRaceMatrix, WagerFacade } from '@amwager/wager/data-access';
import { AccountFacade } from '@amwager/account/data-access';
import { RunnerComponent } from '../runner/runner.component';
import { MatrixComponent } from '../matrix/matrix.component';
import { BetAmountComponent } from '../bet-amount/bet-amount.component';

// Third party
// import * as _ from 'lodash';
import _ from 'lodash';
import { take, takeUntil } from 'rxjs';

@Component({
  selector: 'feature-ion-race',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonContent,
    IonButton,
    IonSelect,
    IonSelectOption,
    IonIcon,
    RaceStringToRangePipe,
    GetCurrentRacePipe,
    GetRaceStatusPipe,
    SortEventsPipe,
    GetEventStatusPipe,
    GetTrackTypePipe,
    ConvertToRangePipe,
    LegHeightDirective,
    OrdinalsPipe,
    HorseWeightPipe,
    RunnerComponent,
    RaceFinalComponent,
    NumberWithCommasPipe,
    MatrixComponent,
    CountdownPipe,
    FormatAmountPipe,
    SanitizerPipe
  ],
  providers: [DatePipe],
  templateUrl: './race.component.html',
  styleUrls: ['./race.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RaceComponent extends
UnsubscribeObservableService implements OnInit, OnChanges, AfterViewInit {
  @Input() selectedEvent!: IGetEventsDetailsResponse;

  @ViewChild('swipeRaceSectionTemplateRef') swipeRaceSectionTemplateRef!: ElementRef;

  selectedRace!: ISelectedRace;
  poolMatrix!: any;
  isShowRunnners = true;
  selectedPool!: IPool;
  pool!: string;
  modifier!: string;
  baseAmount!: number;
  setBaseAmount!: number;
  dblPkArray!: any;
  @Input() events!: any;
  PoolIds: string[] = ['EX','QU','TRL','TRI','SPR','OMN','PEN','HEX'];

  @Input() selectedModifier!: string;
  @Input() currentSelectedFromEventStatus?: string | null;

  isExoticSelections!: boolean;
  modal: any;

  runId!: string;
  eventId!: string;
  raceId!: string;

  liveVideoUrl!: string;
  playLiveVideo = false;
  @Input() triggerLiveVideo!: boolean;
  @Input() triggerAutoUpdateEvents!: boolean;
  @Output() doCloseVideoFn = new EventEmitter<boolean>();
  @Output() doSetRaceStatusFn = new EventEmitter<number>();

  private previousSelectedEventID!: string;
  private previousSelectedRaceID!: string;

  constructor(
    readonly cdRef: ChangeDetectorRef,
    readonly permissionService: PermissionService,
    private readonly sessionService: SessionService,
    readonly router: Router,
    private readonly elementRef: ElementRef,
    readonly wagerFacade: WagerFacade,
    private readonly accountFacade: AccountFacade,
    private readonly commonFacade: CommonFacade,
    private readonly modalCtrl: ModalController,
  ) {

    super();



    this.observerGetSelectedRace();
    // TODO
    this.wagerFacade.toUpdateGeneralEvents$().subscribe((toUpdate) => {
      if (!toUpdate) return;

      // console.log('toUpdateGeneralEvents:race')

      this.wagerFacade.getSelectedRace$()
        .pipe(take(1))
        .subscribe((race?: ISelectedRace) => {
          if (!race || !race?.RaceId || !race?.runId || !race?.eventId) return;

          if (
            this.raceId === String(race.RaceId)
            && this.runId === String(race.runId)
            && this.eventId === String(race.eventId)
          ) return;

          this.selectedRace = race;
        });
    });

    this.wagerFacade.getEventLiveVideo$()
      .subscribe((callback) => {
        if (callback === undefined || callback?.response === undefined) return;

        this.playLiveVideo = true;
        this.triggerLiveVideo = true;
        this.liveVideoUrl = callback?.response.Link;
        this.cdRef.markForCheck(); // re-render for template
      });

    this.accountFacade.isGetAccountPreferencesSuccess$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((callback) => {

        if (callback === undefined) return;

        const response = callback?.response?.AccountPreferences;
        this.isExoticSelections = response?.IsExoticSelections;
        this.cdRef.markForCheck();
      });

    this.wagerFacade.getRaceMatrix$()
      .subscribe((callback) => {

        if (callback === undefined) return;

        this.poolMatrix = callback;
        this.cdRef.markForCheck();
      });

  }

  ngOnInit() {
    this.baseAmount = 0;
    this.setBaseAmount = 0;

    if (this.selectedPool !== undefined) {
      this.baseAmount = this.selectedPool.WagerMinimum || 0;
      this.setBaseAmount = this.selectedPool.WagerMinimum || 0;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (this.selectedRace) return;
    // console.log('RACE:onchanges:RACE:', changes);

    if (
      changes['selectedEvent'] !== undefined &&
      changes['selectedEvent'].currentValue !== undefined
    ) {
      // console.log('RACE:onchanges:RACE:current:selectedEvent', changes['selectedEvent'].currentValue.id);
      // console.log('RACE:onchanges:RACE:previousSelectedEventID:old:', this.previousSelectedEventID);
      // console.log('RACE:onchanges:RACE:EventStatus', changes['selectedEvent']?.currentValue?.ToteResponse?.EventDetail?.EventStatus);

      if (changes['selectedEvent'].currentValue.id) {
        // triggered live video
        if (this.playLiveVideo) return;
      }

      // proceed if selected event ID is not the same from Parent input
      // skip if selected event ID is the same from Parent input
      if (
        changes['selectedEvent'].currentValue.id !== this.previousSelectedEventID && // if different event ID
        this.triggerAutoUpdateEvents
      ) {

        this.previousSelectedEventID = changes['selectedEvent'].currentValue.id;
        this.setDefaultValues();

      }
      // else console.log('RACE:onchanges:RACE:ERROR',);

      if (
        changes['selectedEvent'].currentValue?.ToteResponse?.EventDetail?.currentRace?.RaceId
        !== this.previousSelectedRaceID &&
        this.triggerAutoUpdateEvents
      ) {

        this.previousSelectedRaceID
          = changes['selectedEvent'].currentValue?.ToteResponse?.EventDetail?.currentRace?.RaceId;
        this.setDefaultValues();

      }

      // if (
      //   // if close event
      //   changes['selectedEvent'].currentValue.ToteResponse?.EventDetail?.EventStatus === 'Closed' ||
      //   // if close status
      //   changes['currentSelectedFromEventStatus']?.currentValue === 'C'
      //   ) {
      //     // same as Pro UI no changes
      // }

    }
    // console.log('selectedRace:ngOnChanges:', this.selectedRace)

    // if (
    //   changes['selectedEvent'] !== undefined &&
    //   changes['selectedEvent'].currentValue !== undefined
    // ) {
    //   if (changes['selectedEvent'].currentValue.id) {

    //     // triggered live video
    //     if (this.playLiveVideo) return;

    //     // this.selectedRace = this.selectedEvent?.ToteResponse?.EventDetail?.currentRace as IRace;
    //     this.selectedPool = this.selectedRace?.Pools?.[0] as IPool;

    //     this.pool = 'WIN';
    //     this.modifier = 'Straight';
    //     // empty means default value Straight
    //     this.selectedModifier = '';
    //     this.dblPkArray = '';

    //     if (this.selectedPool !== undefined) {
    //       this.baseAmount = this.selectedPool.WagerMinimum || 0;
    //       this.setBaseAmount = this.selectedPool.WagerMinimum || 0;
    //     }

    //     // auto scroll view
    //     setTimeout(()=>{
    //       this.scrollToPage(this.selectedRace?.RaceId || 0);
    //     }, 100);

    //     this.doSetRaceStatusFn.emit(this.selectedRace?.RaceStatus);
    //   }
    // }

    // if (changes['selectedPool'] !== undefined) {
    //   if (changes['selectedPool'].currentValue) {
    //     this.baseAmount = this.selectedPool.WagerMinimum;
    //     this.setBaseAmount = this.selectedPool.WagerMinimum;
    //   }
    // }

    this.cdRef.markForCheck();
    // console.log(changes['selectedEvent']);

    // this.selectedRace = this.selectedEvent?.ToteResponse?.EventDetail?.currentRace as IRace;
    // this.selectedPool = this.selectedRace?.Pools[0];

    // console.log(this.selectedPool);
    // if (this.selectedPool !== undefined) {
    //   this.baseAmount = this.selectedPool.WagerMinimum;
    //   this.setBaseAmount = this.selectedPool.WagerMinimum;
    // }

  }

  ngAfterViewInit(): void {
    null;
    // update branch
    // this.scrollToPage(this.selectedRace?.RaceId || 0);

    // const activePaginate = this.elementRef.nativeElement.querySelector(
    //   '.current-races .active-paginate'
    // );
    // activePaginate.scrollIntoView({ behavior: 'smooth', inline: 'center' });
  }

  /**
   * Observers
   */
  observerGetSelectedRace(): void {
    this.wagerFacade.getSelectedRace$()
      .subscribe((race?: ISelectedRace) => {
        if (!race || !race?.RaceId || !race?.runId || !race?.eventId) return;


        this.selectedRace = race;

        // encase empty entries
        const updatedRunners = this.processFillInRunnersNonDblPk(this.selectedRace.Runners);
        const updatedRace = _.cloneDeep(this.selectedRace);
        updatedRace.Runners = updatedRunners;
        this.selectedRace = updatedRace;

        // avoid proccess for the same race #
        if (
          this.raceId === String(race.RaceId)
          && this.runId === String(race.runId)
          && this.eventId === String(race.eventId)
        ) null;
        else {
          // clear matrix every new Race ID
          this.wagerFacade.clearRaceAllOddsMatrixes('RaceComponent:observerGetSelectedRace');
          this.wagerFacade.clearSelectedRaceMatrix('RaceComponent:observerGetSelectedRace');
          this.wagerFacade.clearSelectedRacePoolsTotals('RaceComponent:observerGetSelectedRace');
          this.wagerFacade.clearSelectedRaceWillPays('RaceComponent:observerGetSelectedRace');

          this.raceId = String(race.RaceId);
          this.runId = String(race.runId);
          this.eventId = String(race.eventId);

          // build matrix tables
          this.toBuildMatrixTables({
            ...race as IRace,
            runId: this.runId,
            eventId: this.eventId
          });
        }

        this.cdRef.markForCheck();
      });
  }

  setDefaultValues(): void {
    // console.log('RACE:onchanges:RACE:DEFAULT:SET');

    // this.selectedRace = this.selectedEvent?.ToteResponse?.EventDetail?.currentRace as IRace;
    this.selectedPool = this.selectedRace?.Pools?.[0] as IPool;

    this.pool = 'WIN';
    this.modifier = 'Straight';
    // empty means default value Straight
    this.selectedModifier = '';
    this.dblPkArray = '';

    if (this.selectedPool !== undefined) {
      this.baseAmount = this.selectedPool.WagerMinimum || 0;
      this.setBaseAmount = this.selectedPool.WagerMinimum || 0;
    }

    // auto scroll view
    setTimeout(()=>{
      this.scrollToPage(this.selectedRace?.RaceId || 0);
    }, 100);

    this.doSetRaceStatusFn.emit(this.selectedRace?.RaceStatus);
  }

  scrollToPage(page: any) {
    if (this.swipeRaceSectionTemplateRef === undefined) return;
    const paginationItems = this.swipeRaceSectionTemplateRef.nativeElement.children;
    const activeItem = paginationItems[page - 1];

    if (activeItem) {
      const containerWidth = this.swipeRaceSectionTemplateRef.nativeElement.offsetWidth;
      const itemWidth = activeItem.offsetWidth;
      const itemLeft = activeItem.offsetLeft;
      const scrollPosition = itemLeft - containerWidth / 2 + itemWidth / 2;

      this.swipeRaceSectionTemplateRef.nativeElement.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });

    }
  }

  toBuildMatrixTables(race: IRace & {runId: string, eventId: string}): void {
    this.wagerFacade.updateRaceMatrix('MatrixComponent:construct', undefined);
    this.wagerFacade.updateRacePoolsTotals('MatrixComponent:construct', undefined);

    if (!race || !race?.RaceId) return;

    const raceId = race?.RaceId;
    const eventId = race?.eventId;
    const runId = race?.runId;

    if (!raceId || !eventId || !runId) return;

    const poolList = [
      'TRU',
      ...race?.PoolList?.split(",") || [],
    ];

    // get pool matrixes
    _.forEach(poolList, (poolId: string) => {
      if (!poolId) return;

      this.wagerFacade.getPoolMatrix(
        'RaceComponent:toBuildMatrixTables',
        {
          raceId: raceId,
          eventId: eventId,
          runId: runId,
          poolId
        }
      );
    });

    // get pools totals
    this.wagerFacade.getPoolsTotals(
      'RaceComponent:toBuildMatrixTables',
      {
        raceId: raceId,
        eventId: eventId,
        runId: runId,
      }
    );

    // get will pays
    this.wagerFacade.getWillPays(
      'RaceComponent:toBuildMatrixTables',
      {
        raceId: raceId,
        eventId: eventId,
        runId: runId,
      }
    );

    // get race odd matrixes with WIN pool
    this.wagerFacade.getRaceAllOddsMatrixes(
      'RaceComponent:toBuildMatrixTables',
      'WIN',
      {
        raceId: raceId,
        eventId: eventId,
        runId: runId,
        poolId: 'WIN'
      }
    );

    // get race odd matrixes with TRU pool
    this.wagerFacade.getRaceAllOddsMatrixes(
      'RaceComponent:toBuildMatrixTables',
      'TRU',
      {
        raceId: raceId,
        eventId: eventId,
        runId: runId,
        poolId: 'TRU'
      }
    );
  }

  checkDataDBLPK(): boolean {

    if (this.selectedRace.Runners === undefined)
      return false;

    if (!this.selectedRace.Runners.length)
      return false;

    // if (this.selectedRace.Runners[0].Entries === undefined)
    //   return false;

    return true;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectRace($event: any, race: IRace): void {
    // clear active legs/round
    this.clearLegRoundSelector();
    this.isShowRunnners = false;
    this.selectedRace = race;
    this.selectedPool = (this.selectedRace as IRace)?.Pools[0];
    this.selectedModifier = '';
    this.dblPkArray = '';

    this.pool = 'WIN';
    this.modifier = 'Straight';

    this.wagerFacade.selectedRace(
      'RaceComponent:selectRace',
      {
        ...race,
        runId: this.selectedEvent.ToteResponse.RunId,
        eventId: this.selectedEvent.ToteResponse.EventDetail.EventId
      }
    );

    // $event?.target?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

    this.doSetRaceStatusFn.emit(this.selectedRace?.RaceStatus);

    this.scrollToPage(this.selectedRace?.RaceId || 0);

    this.cdRef.markForCheck(); // re-render for template

    setTimeout(() => {
      this.isShowRunnners = true;
      this.cdRef.markForCheck(); // re-render for template
    }, 100);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectPool($event: any): void {

    // console.log('selectPool:', $event)
    // const pool: IPool =  $event.target.value as IPool;

    const currentPool =  $event.target.value;
    const foundObject: IPool = _.find(this.selectedRace?.Pools, ['PoolName', currentPool]) as IPool;

    // if (this.pool !== currentPool) {

      if (
        !this.isExoticSelections ||
        !this.checkExotic(foundObject.PoolId)
      ) {
        this.clearActiveAllLeg();
        this.clearLegRoundSelector();
      }

      // this.clearActiveAllLeg();
      // this.clearLegRoundSelector();
      this.commonFacade.setIsShowFooter(true);
      this.wagerFacade.setIsShowBetPreview(false);
      // const betSection = this.elementRef.nativeElement.querySelector('.bet-footer-section');
      // betSection.classList.remove('active');
    // }

    // this.selectedPool = pool;
    this.selectedPool = foundObject;
    this.selectedModifier = '';
    //store prev value
    this.pool = currentPool;
    this.modifier = 'Straight';

    if (this.selectedPool !== undefined) {
      if ((
        (this.baseAmount < this.selectedPool.WagerMinimum) ||
        (this.baseAmount > this.selectedPool.WBMaximum)
      )) {
        this.baseAmount = this.selectedPool.WagerMinimum;
        this.setBaseAmount = this.selectedPool.WagerMinimum;
      }
    }

    // if (this.selectedPool !== undefined) {
    //   this.baseAmount = this.selectedPool.WagerMinimum;
    //   this.setBaseAmount = this.selectedPool.WagerMinimum;
    // }

    // console.log(this.selectedEvent);
    // console.log(this.selectedRace);
    // console.log(foundObject);

    // if (foundObject !== undefined && foundObject) {
      // if (foundObject.PoolId === 'DBL') {
      //   this.dblPkArray = this.storeDBLPKraces(
      //     this.selectedEvent.ToteResponse.EventDetail.Races,
      //     this.selectedRace.RaceId,
      //     (this.selectedRace.RaceId + 1)
      //   );
      // }
    // }

    const startsWithPK = /^PK/.test(foundObject.PoolId || '');
    const wordWithPK = /^PICK|Pick|pick/.test(foundObject.PoolName || '');

    if (this.selectedEvent !== undefined && this.selectedRace !== undefined) {

      if (!this.checkDataDBLPK()) {
        this.cdRef.markForCheck();
        return;
      }

      if (startsWithPK || wordWithPK) {
        // const pk = foundObject.PoolId?.match(/(\d)$/);
        if (
          this.extractNumber(foundObject.PoolId) &&
          this.extractNumber(foundObject.PoolId) !== Number(NaN)
        ) {
          this.dblPkArray = this.storeDBLPKraces(
            this.selectedEvent.ToteResponse.EventDetail.Races,
            this.selectedRace.RaceId as number,
            this.extractNumber(foundObject.PoolId)
          );
          // this.dblPkArray = this.storeDBLPKraces(
          //   this.selectedEvent.ToteResponse.EventDetail.Races,
          //   this.selectedRace.RaceId as number,
          //   Number(pk[1])
          // );
          // console.log(this.dblPkArray);
        }
      }
      else if (foundObject.PoolId === 'GSL') {
        this.dblPkArray = this.storeDBLPKraces(
          this.selectedEvent.ToteResponse.EventDetail.Races,
          this.selectedRace.RaceId as number,
          (4)
        );
      }
      else if (foundObject.PoolId === 'DBL') {
        this.dblPkArray = this.storeDBLPKraces(
          this.selectedEvent.ToteResponse.EventDetail.Races,
          this.selectedRace.RaceId as number,
          (2)
        );
      } else {
        this.dblPkArray = '';
        const updatedRunners = this.processFillInRunnersNonDblPk(this.selectedRace.Runners);
        const updatedRace = _.cloneDeep(this.selectedRace);
        updatedRace.Runners = updatedRunners;
        this.selectedRace = updatedRace;
      }
    }

    if (
      foundObject.PoolId === 'GSL' ||
      foundObject.PoolId === 'DBL' ||
      startsWithPK || wordWithPK
    ) {
      this.dblPkArray = this.processFillInRunners(this.dblPkArray);
    }

    this.cdRef.markForCheck(); // re-render for template
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectModifier($event: any): void {

    let modifier =  $event.target.value;
    // if (this.selectedModifier !== this.convertWordsToAbbre(modifier)) {

      if (
        !this.isExoticSelections ||
        !this.checkExotic(this.selectedPool.PoolId)
      ) {
        this.clearActiveAllLeg();
        this.clearLegRoundSelector();
      }

      // this.clearActiveAllLeg();
      // this.clearLegRoundSelector();
      this.commonFacade.setIsShowFooter(true);
      this.wagerFacade.setIsShowBetPreview(false);
      // const betSection = this.elementRef.nativeElement.querySelector('.bet-footer-section');
      // betSection.classList.remove('active');
    // }

    switch(modifier) {
      case 'Box':
          modifier = 'BX'
        break;
      case 'KeyBox':
          modifier = 'KB'
        break;
      case 'PowerBox':
          modifier = 'PB'
        break;
      case 'KeyWheel':
          modifier = 'KW'
        break;
      case 'DutchCost':
          modifier = 'DutchCost'
        break;
      case 'ABC':
          modifier = 'ABC'
        break;
      default:
          modifier = ''
        break;
    }

    this.selectedModifier = modifier;
    this.cdRef.markForCheck(); // re-render for template
  }

  extractNumber(pk: string): number {
    const match = pk.match(/\d+/);
    return match ? parseInt(match[0], 10) : NaN;
  }

  // for couple entry with extra entry
  processFillInRunners(data: any[]): any[] {

    let previousRunners: any[] = [];

    const updatedData = data.map(item => {
      const currentRunners = _.cloneDeep(item.Runners);

      currentRunners.forEach((
        currentRunner: {
          RunnerId: any; Entries: {
            RunnerId?: number, EntryId: any; Name: string; isReplica: boolean;
          }[];
        }) => {

        if (
          currentRunner.RunnerId &&
          (
            !currentRunner.Entries ||
            currentRunner.Entries.length === 0 ||
            !currentRunner.Entries.some(entry => entry.Name)
          )
        ) {
          currentRunner.Entries = currentRunner.Entries || [];
          currentRunner.Entries.push({
            RunnerId: currentRunner.RunnerId,
            EntryId: null,
            Name: '',
            isReplica: false
          });
        }

        if (!_.isEmpty(previousRunners)) {

          const prevRunner = _.find(previousRunners, { RunnerId: currentRunner.RunnerId });

          if (prevRunner) {

            _.forEach(prevRunner.Entries, prevEntry => {
              if (prevEntry.EntryId !== undefined &&
                  !_.some(currentRunner.Entries, { EntryId: prevEntry.EntryId })) {
                currentRunner.Entries.push({
                  EntryId: prevEntry.EntryId,
                  Name: '',
                  isReplica: true
                });
              }
            });
          }
        }
      });

      previousRunners = _.cloneDeep(currentRunners);

      return {
        ...item,
        Runners: currentRunners
      };
    });

    const maxTotalEntries = _.max(
      _.map(updatedData, item =>
        _.sumBy(item.Runners, (runner: any) => runner.Entries.length)
      )
    ) || 0;

    const finalData = updatedData.map(item => {
      const extendedRunners = _.cloneDeep(item.Runners);
      const totalEntries = _.sumBy(extendedRunners, (runner: any) => runner.Entries.length);

      for (let i = totalEntries; i < maxTotalEntries; i++) {
        extendedRunners.push({
          RunnerId: extendedRunners.length + 1,
          Entries: [{ toHide: true }],
          Odds: '',
          toHide: true
        });
      }

      return {
        ...item,
        Runners: extendedRunners
      };
    });

    while (finalData.length < 5) {
      const newRunners = Array.from({ length: maxTotalEntries || 1 }, (_, i) => ({
        RunnerId: i + 1,
        Entries: [{ toHide: true }],
        Odds: '',
        toHide: true
      }));

      finalData.push({ RaceId: 0, Runners: newRunners });
    }

    return finalData;
  }

  // for couple entry without extra entry
  // processFillInRunners(data: any[]): any[] {
  //   const totalEntries: any[] = [];

  //   data.forEach((item, index) => {
  //     let total = 0;
  //     item.Runners.forEach((runner: { Entries: string | any[]; }) => {
  //       total += runner.Entries.length;
  //     });
  //     totalEntries.push(total);
  //   });

  //   const maxTotalEntries = _.max(totalEntries);

  //   const updatedData = data.map((item, index) => {
  //     const extendedRunners = [...item.Runners];

  //     for (let i = totalEntries[index]; i < maxTotalEntries; i++) {
  //       extendedRunners.push({
  //         RunnerId: extendedRunners.length + 1,
  //         Entries: [{ toHide: true }],
  //         Odds: '',
  //         toHide: true
  //       });
  //     }

  //     const updatedRunners = extendedRunners.map(runner => ({
  //       ...runner,
  //       toHide: runner.Odds || runner.Scratch ? false : true
  //     }));

  //     return {
  //       ...item,
  //       Runners: updatedRunners
  //     };
  //   });

  //   while (updatedData.length < 5) {
  //     const newRunners = Array.from({ length: maxTotalEntries || 1 }, (_, i) => ({
  //       RunnerId: i,
  //       Entries: [{ toHide: true }],
  //       Odds: '',
  //       toHide: true
  //     }));

  //     updatedData.push({ RaceId: 0, Runners: newRunners });
  //   }

  //   return updatedData;
  // }

  processFillInRunnersNonDblPk(data: any[] = []): any[] {
    return _.map(data, item => {
      const clonedItem = { ...item };
      if (!clonedItem.Entries || clonedItem.Entries.length === 0) {
        clonedItem.Entries = [{
          RunnerId: clonedItem.RunnerId,
          EntryId: null,
          Name: '',
          isReplica: false
        }];
      }
      return clonedItem;
    });
  }

  hasPermission(): boolean {
    if (this.permissionService.isAllowed()) {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }

  checkExotic(prevPoolId?: string): boolean {
    // const startsWithPK = /^PK/.test(this.selectedPool?.PoolId || '');
    // const prevStartsWithPK = /^PK/.test(prevPoolId || '');
    if (
      this.isExoticSelections &&
      (
        // this.selectedPool?.PoolId === 'EX' ||
        // this.selectedPool?.PoolId === 'TRI' ||
        // this.selectedPool?.PoolId === 'SPR' ||
        // this.selectedPool?.PoolId === 'PEN' ||
        // this.selectedPool?.PoolId === 'HEX' ||
        // this.selectedPool?.PoolId === 'DBL' ||
        this.PoolIds.includes(this.selectedPool?.PoolId)
        // ||
        // startsWithPK
      ) &&
      (
        // prevPoolId === 'EX' ||
        // prevPoolId === 'TRI' ||
        // prevPoolId === 'SPR' ||
        // prevPoolId === 'PEN' ||
        // prevPoolId === 'HEX' ||
        // prevPoolId === 'DBL' ||
        this.PoolIds.includes(prevPoolId || '')
        // ||
        // prevStartsWithPK
      )
    ) {
      return true;
    }
    else return false;
  }

  clearActiveAllLeg(): void {
    const divLegs = this.elementRef.nativeElement.querySelectorAll(`.mode-place-races span.mode`);
    divLegs.forEach((leg: HTMLElement) => {
      leg?.classList.remove('active');
    });
  }

  clearLegRoundSelector(): void {
    const divLegs = this.elementRef.nativeElement.querySelectorAll('.table-bet [class^="runner"]');
    // const divLegs = this.elementRef.nativeElement.querySelectorAll('.table-bet [class^="leg"]');
    divLegs.forEach((leg: HTMLElement) => {
      if (leg?.classList.contains('active'))
        leg?.classList.remove('active');
        leg?.classList.remove('couple-entry');
        leg.innerHTML = '';
    });
  }

  storeDBLPKraces(races: any, raceId: number, pk: number): Array<any> {
    const startIndex = _.findIndex(races, { RaceId: raceId });
    // console.log(startIndex);
    // console.log(startIndex + pk);
    // console.log(races);
    const result = _.slice(races, startIndex, startIndex + pk);
    return result;
  }

  convertWordsToAbbre(word: string): string {
    let modifier =  word;

    switch(modifier) {
      case 'Box':
          modifier = 'BX'
        break;
      case 'KeyBox':
          modifier = 'KB'
        break;
      case 'PowerBox':
          modifier = 'PB'
        break;
      case 'KeyWheel':
          modifier = 'KW'
        break;
      default:
          modifier = ''
        break;
    }

    return modifier;
  }

  async openMatrix(): Promise<void> {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('RaceComponent:openMatrix', false);
    }

    // if (!this.hasPermission()) return;
    if (this.sessionService.getUserEmail() === GUEST || !this.sessionService.hasToken()) {
      this.router.navigate(['login']);

      return;
    }

    this.wagerFacade.updateTriggerMatrixModal('RaceComponent:openMatrix');
  }

  async betAmount(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: BetAmountComponent,
      cssClass: 'bet-amount',
      componentProps: {
        pool: this.selectedPool
      }
    });

    modal.onDidDismiss().then((res) => {
      if (!res.data) return;

      if (
        Number(res.data.amount) &&
        !isNaN(Number(res.data.amount)) &&
        Number(res.data.amount) >= Number(res.data.minBet) &&
        Number(res.data.amount) <= Number(res.data.maxBet)
      ) {
        this.baseAmount = Number(res.data.amount);
        this.setBaseAmount = Number(res.data.amount);
      }

      this.cdRef.markForCheck();
    });

    modal.present();
  }

  closeVideo() {
    this.playLiveVideo = !this.playLiveVideo;
    this.triggerLiveVideo = !this.triggerLiveVideo;
    this.doCloseVideoFn.emit(true);
  }

}
